import {
  popUp,
  fadeIn,
  slideScale,
  fadeScaleXscale,
  fadeMotionPath,
  popUpFadeInRotate,
} from "@/utils/BlockTextImage/handleAnimations/modules";

export default function handleAnimationStyle(
  optionsAnimImages,
  imagesTl,
  images,
  circles,
  circleTl,
  sectionName,
  isHero,
  imageStyles,
  isCircleAnimated,
  containerImageRef,
  rotationTl
) {
  switch (optionsAnimImages.type) {
    case "fadeIn":
      fadeIn(
        images,
        imagesTl,
        circles,
        circleTl,
        imageStyles,
        sectionName,
        isHero,
        isCircleAnimated,
        optionsAnimImages
      );
      break;
    case "fadeMotionPath":
      fadeMotionPath(imagesTl, images, optionsAnimImages, sectionName);
      break;
    case "popUp":
      popUp(images, imagesTl);
      break;
    case "popUp&FadeInRotate":
      popUpFadeInRotate(
        images,
        imagesTl,
        containerImageRef,
        rotationTl,
        optionsAnimImages
      );
      break;
    case "slideScale":
      slideScale(imagesTl, optionsAnimImages, sectionName);
      break;
    case "fadeScaleXscale":
      fadeScaleXscale(
        imagesTl,
        sectionName,
        isCircleAnimated,
        circles,
        optionsAnimImages
      );
      break;
  }
}
